import { useDashboardStore } from '../../dashboard-store';
import { EDashboard } from '../../types';
import { Switch } from '@mantine/core';
import { Button } from '../ui/button';
import { ExportPngButton, ExportPdfButton } from '../export-button';
import ShareDashboardURL from '../../../../components/ShareDashboardURL';

interface NavigationPanelProps {
  onDashboardChange: (dashboardId: EDashboard) => void;
  activeDashboard: EDashboard;
  availableDashboards?: {
    main: boolean;
    eg: boolean;
    di: boolean;
    code: boolean;
  };
  projectName?: string;
  jobId?: string;
}

const navButtons = [
  { label: 'Main', id: EDashboard.MAIN },
  { label: 'EG', id: EDashboard.EG },
  { label: 'DI', id: EDashboard.DI },
  { label: 'Code', id: EDashboard.CODE },
];

// Feature flag to enable/disable grid lock functionality
const ENABLE_GRID_LOCK = false;

export const DashboardNavPanel = ({
  onDashboardChange,
  activeDashboard,
  availableDashboards,
  projectName,
  jobId,
}: NavigationPanelProps) => {

  const isResizable = useDashboardStore((state) => state.isResizable);
  const setIsResizable = useDashboardStore((state) => state.setIsResizable);

  const getClassName = (id: EDashboard) =>
    activeDashboard === id
      ? 'w-24 border-green-700 border-green-700 bg-green-700 bg-opacity-60 text-green-100'
      : 'w-24';

  const handleClick = (id: EDashboard) => () => {
    onDashboardChange(id);
  };

  const tabs = navButtons
    .filter(({ id }) => {
      if (availableDashboards) {
        return Boolean(availableDashboards[id]);
      }
      return true;
    })
    .map((button) => (
      <Button
        key={button.id}
        onClick={handleClick(button.id)}
        className={getClassName(button.id)}
      >
        {button.label}
      </Button>
    ));

  return (
    <div className="flex w-full items-center justify-between">
      <div className="flex items-center gap-4">
        <div className="flex gap-2">{tabs}</div>
      </div>
      <div className="flex items-center gap-4">
        {jobId && <ShareDashboardURL jobId={jobId} />}
        <ExportPngButton activeDashboard={activeDashboard} projectName={projectName} />
        <ExportPdfButton activeDashboard={activeDashboard} projectName={projectName} />
      {ENABLE_GRID_LOCK && (
        <div className="flex items-center gap-2">
          <div>
            <span className="text-sm leading-none text-deep-gray-400">
              Lock grid
            </span>
          </div>
          <Switch
            checked={!isResizable}
            onChange={() => {
              setIsResizable(!isResizable);
            }}
            labelPosition="left"
            size="xs"
            classNames={{
              label:
                'text-deep-gray-400 text-sm leading-none select-none cursor-pointer',
              input: 'peer',
              track:
                'bg-deep-gray-600 cursor-pointer border-none peer-checked:bg-green-600',
              thumb: 'bg-deep-gray-700 border-none',
            }}
          />
        </div>
      )}
      </div>
    </div>
  );
};